const KeenSlider = window.KeenSlider

const { setInitialised, useArrows } = window.BAO.Carousel.plugins
const { isXsViewport, isSmViewport } = window.BAO.MediaBreakpoints

class ProductCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.handleResize = this.handleResize.bind(this)
    this.initCarousel()

    window.addEventListener('resize', this.handleResize)
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    window.removeEventListener('resize', this.handleResize)

    this.destroyCarousel()
  }

  initCarousel () {
    this.destroyCarousel()
    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    const slideElements = this.els.slides.element.querySelectorAll(
      this.els.slide.selector,
    )
    const slideCount = slideElements.length

    const threshold = isXsViewport ? 2 : isSmViewport ? 3 : 4

    if (slideCount <= threshold) {
      return null
    }

    this.els.controls.element.setAttribute('aria-hidden', 'false')

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 300,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 2.2,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 3.2,
            },
          },
          '(min-width: 901px)': {
            slides: {
              perView: 4.2,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }

  handleResize () {
    const prevViewportState = this.currentViewportState

    if (isXsViewport) {
      this.currentViewportState = 'xs'
    } else if (isSmViewport) {
      this.currentViewportState = 'sm'
    } else {
      this.currentViewportState = 'lg'
    }

    if (prevViewportState !== this.currentViewportState) {
      this.initCarousel()
    }
  }

  destroyCarousel () {
    if (this.carousel) {
      this.carousel.destroy()
      this.carousel = null
    }
    this.els.controls.element.setAttribute('aria-hidden', 'true')
  }
}

if (!customElements.get('product-carousel')) {
  customElements.define('product-carousel', ProductCarousel)
}
